import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { goToPage } from '@epi-actions/navigation';
import {
  ReportTypeVirike,
  REPORTS_QUERY_NAME,
  REPORTS_SEARCH_NAME
} from '@epi-constants/externalReport';

export const useExternalReportsTabs = () => {
  const [showFooter, setShowFooter] = useState(false);
  const { search, pathname } = useLocation();
  const dispatch = useDispatch();

  const handleFooterVisibility = tabName =>
    setShowFooter(tabName === ReportTypeVirike.reports);

  const handleURLChange = tabName =>
    dispatch(goToPage(pathname + REPORTS_QUERY_NAME + tabName));

  const handleOnTabChange = tabName => {
    handleFooterVisibility(tabName);
    handleURLChange(tabName);
  };

  const urlParams = new URLSearchParams(search);
  const indexType = urlParams.get(REPORTS_SEARCH_NAME);

  const defaultTabName =
    indexType && ReportTypeVirike[indexType]
      ? ReportTypeVirike[indexType]
      : ReportTypeVirike.cardOrders;

  return {
    showFooter,
    handleOnTabChange,
    defaultTabName
  };
};
